import * as Yup from 'yup';

import { attachedDocumentConfigNames } from '../types/configNames';
import { AttachedDocumentsTabFields } from '../types/fieldEnums';
import { type TValidationConfig } from '../types/configs';

import { getDateValidation, getObjectValidation, getStringValidation } from './validations';

const getAttachmentSchema = (operation?: string, validationConfig?: TValidationConfig) =>
  Yup.object().shape({
    code: getObjectValidation({
      field: attachedDocumentConfigNames[AttachedDocumentsTabFields.code],
      operation,
    }),
    referenceNumber: getStringValidation({
      field: attachedDocumentConfigNames[AttachedDocumentsTabFields.referenceNumber],
      operation,
      validationConfig,
    }),
    attachmentDate: getDateValidation({
      field: attachedDocumentConfigNames[AttachedDocumentsTabFields.attachmentDate],
      operation,
      validationConfig,
    }),
    fileUrl: getStringValidation({
      field: attachedDocumentConfigNames[AttachedDocumentsTabFields.fileUrl],
      operation,
      validationConfig,
    }),
  });

export default getAttachmentSchema;
